var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                staticClass: "w-50",
                attrs: {
                  id: "perPageSelect",
                  size: "sm",
                  options: _vm.pageOptions,
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-col", { staticClass: "my-1", attrs: { md: "4", sm: "8" } }),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { md: "6" } },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                label: "Filter",
                "label-cols-sm": "3",
                "label-align-sm": "right",
                "label-size": "sm",
                "label-for": "filterInput",
              },
            },
            [
              _c(
                "b-input-group",
                { attrs: { size: "sm" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "filterInput",
                      type: "search",
                      placeholder: "Type to Search",
                    },
                    model: {
                      value: _vm.filter,
                      callback: function ($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter",
                    },
                  }),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { disabled: !_vm.filter },
                          on: {
                            click: function ($event) {
                              _vm.filter = ""
                            },
                          },
                        },
                        [_vm._v(" Clear ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              items: _vm.customerList,
              fields: _vm.fields,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
              filter: _vm.filter,
              "filter-included-fields": _vm.filterOn,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(companyName)",
                fn: function (data) {
                  return [
                    data.item.companyName === null
                      ? _c("b-badge", { attrs: { variant: "primary" } }, [
                          _vm._v(" Not a Company "),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(data.item.companyName) + " "),
                  ]
                },
              },
              {
                key: "cell(surname)",
                fn: function (data) {
                  return [
                    data.item.surname === null
                      ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(" " + _vm._s(data.item.companyName) + " "),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(data.item.surname) + " "),
                  ]
                },
              },
              {
                key: "cell(otherName)",
                fn: function (data) {
                  return [
                    data.item.otherName === null
                      ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(" " + _vm._s(data.item.companyName) + " "),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(data.item.otherName) + " "),
                  ]
                },
              },
              {
                key: "cell(status)",
                fn: function (data) {
                  return [
                    data.item.status === 1
                      ? _c("b-badge", { attrs: { variant: "info" } }, [
                          _vm._v(" Booked "),
                        ])
                      : data.item.status === 2
                      ? _c("b-badge", { attrs: { variant: "primary" } }, [
                          _vm._v(" Available "),
                        ])
                      : data.item.status === 3
                      ? _c("b-badge", { attrs: { variant: "warning" } }, [
                          _vm._v(" Maintainace "),
                        ])
                      : data.item.status === 4
                      ? _c("b-badge", { attrs: { variant: "danger" } }, [
                          _vm._v(" Broken "),
                        ])
                      : _c("b-badge", { attrs: { variant: "danger" } }, [
                          _vm._v(" Not Available "),
                        ]),
                  ]
                },
              },
              {
                key: "cell(salesPersonId)",
                fn: function (data) {
                  return [
                    data.item.salesPersonId === null
                      ? _c("p", [_vm._v("-")])
                      : _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.getSalePersonName(data.item.salesPersonId)
                            )
                          ),
                        ]),
                  ]
                },
              },
              {
                key: "cell(createdOn)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.formatDate(data.item.createdOn)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          to: _vm.getCustomerData(data.item.id),
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "Edit2Icon" },
                        }),
                        _c("span", [_vm._v("View")]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loading
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }